export default {
    data: () => ({
        'message': 'Email address and password combination is invalid',
        'status': 401,
        'type': 'invalid_login_credentials',
        'code': 0,
        'errors': []
    })
}
